<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h4>Choose from the list below and upload your photo.</h4><br>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>The document you choose to upload will be used to confirm you have the right to work in the UK.</p>
        <p>We check your right to work in the UK to help us understand your eligibility for the course – you will also need to give this information to any potential employers when applying for jobs in future.</p>
        <h4>Remember, the photo of your document must be:</h4><br>
        <ul>
            <li>Of an authentic and original ID document (not a copy of one)</li>
            <li>Clear and in focus (so that the information on your document is readable)</li>
            <li>In colour</li>
            <li>Unaltered by computer software in any way</li>
        </ul><br>
        <img src="https://images.ctfassets.net/2tjc93jinw29/6FCAtxJ5tIXbCuqAgVWc49/09b7d20568d8fa9d3e5e0a7294a771f9/selfie2.jpg?h=600" alt="" class="responsive">


        <InputRadioGroup
            name="Right_To_work"
            :required="checkIsRequired('Right_To_work')"
            :error="formRef.errors.get('Right_To_work')"
            v-model="formRef.Right_To_work"
            :options="getField('Right_To_work')['options']"
            @input="formRef.errors.clear('Right_To_work')"
        >
            <template v-slot:question>
                {{ getField("Right_To_work").question }}
            </template>
        </InputRadioGroup>

        <InputFile
            @input="handleFileInput"
            :error="formRef.errors.get('file')"
            accept="image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
        />
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import InputFile from "../Form/InputFile.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import { ref, markRaw } from "vue";

const emit = defineEmits('buttonDisabled')

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

const whichDocumentDefault = { Right_To_work: "" }

let formRef = markRaw(ref(new Form({
    ...whichDocumentDefault,
    file: null
}, {...whichDocumentDefault, ...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

function handleFileInput(e) {
    formRef.value.file = e;
    emit("buttonDisabled", false)
}

defineExpose({
    formRef
})
</script>

<style scoped>
.responsive {
  width: 100%;
  height: auto;
  padding-left: 10%;
  margin-bottom: 10%;
}
</style>